import { createReducer } from '@reduxjs/toolkit';
var initialState = null;
export default createReducer(initialState, {
    // 'workspace/create/fulfilled': (_, action: PayloadAction<Workspace>) => {
    // 	return action.payload
    // },
    'workspace/load/fulfilled': function (_, action) {
        return action.payload;
    },
    // 'workspace/rename/fulfilled': (state, action: PayloadAction<string>) => {
    // 	state!.name = action.payload
    // },
    // 'collection/create/pending': (state, action: PayloadAction<Collection>) => {
    // 	const collection = action.payload
    // 	state!.collections = state?.collections || []
    // 	state!.collections.push({ name: collection.name, id: collection.id })
    // },
    'collection/delete/pending': function (state, action) {
        // return action.payload.updatedWorkspace
        var deletedCollectionId = action.meta.arg;
        var newCollectionOrder = state.collections.filter(function (colPreview) { return colPreview.id !== deletedCollectionId; });
        state.collections = newCollectionOrder;
    },
    // 'workspace/user/invite/fulfilled': (
    // 	state,
    // 	action: PayloadAction<{
    // 		email: string
    // 		permission: Workspace['users']['$userId']['permission']
    // 	}>
    // ) => {
    // 	const { email, permission } = action.payload
    // 	state!.users[email] = { email, permission, status: 'pending' }
    // },
    // 'workspace/user/remove/fulfilled': (state, action: PayloadAction<string>) => {
    // 	const userId = action.payload
    // 	const users = { ...state!.users }
    // 	const { [userId]: removedUser, ...updatedUsers } = users
    // 	state!.users = updatedUsers
    // },
    // 'workspace/user/changePermission/fulfilled': (
    // 	state,
    // 	action: PayloadAction<{ newPermission: UserPermission; userId: string }>
    // ) => {
    // 	const { userId, newPermission } = action.payload
    // 	state!.users[userId].permission = newPermission
    // },
    'auth/signOut': function () { return initialState; },
});
